import React from 'react';
import virtualScroll from '../../dispatcher/hoc/virtualScroll';

import NavigationBaseTreeGrid from './NavigationBaseTreeGrid';
import { NAVIGATION_BASE_TREE_GRID_PROPS } from './Types';

class NavigationTreeGrid extends NavigationBaseTreeGrid {}
export default virtualScroll<NAVIGATION_BASE_TREE_GRID_PROPS>(NavigationTreeGrid, true);
